export const Prefecture = {
	1: { key: '01', name: '北海道' },
	2: { key: '02', name: '青森県' },
	3: { key: '03', name: '岩手県' },
	4: { key: '04', name: '宮城県' },
	5: { key: '05', name: '秋田県' },
	6: { key: '06', name: '山形県' },
	7: { key: '07', name: '福島県' },
	8: { key: '08', name: '茨城県' },
	9: { key: '09', name: '栃木県' },
	10: { key: '10', name: '群馬県' },
	11: { key: '11', name: '埼玉県' },
	12: { key: '12', name: '千葉県' },
	13: { key: '13', name: '東京都' },
	14: { key: '14', name: '神奈川県' },
	15: { key: '15', name: '新潟県' },
	16: { key: '16', name: '富山県' },
	17: { key: '17', name: '石川県' },
	18: { key: '18', name: '福井県' },
	19: { key: '19', name: '山梨県' },
	20: { key: '20', name: '長野県' },
	21: { key: '21', name: '岐阜県' },
	22: { key: '22', name: '静岡県' },
	23: { key: '23', name: '愛知県' },
	24: { key: '24', name: '三重県' },
	25: { key: '25', name: '滋賀県' },
	26: { key: '26', name: '京都府' },
	27: { key: '27', name: '大阪府' },
	28: { key: '28', name: '兵庫県' },
	29: { key: '29', name: '奈良県' },
	30: { key: '30', name: '和歌山県' },
	31: { key: '31', name: '鳥取県' },
	32: { key: '32', name: '島根県' },
	33: { key: '33', name: '岡山県' },
	34: { key: '34', name: '広島県' },
	35: { key: '35', name: '山口県' },
	36: { key: '36', name: '徳島県' },
	37: { key: '37', name: '香川県' },
	38: { key: '38', name: '愛媛県' },
	39: { key: '39', name: '高知県' },
	40: { key: '40', name: '福岡県' },
	41: { key: '41', name: '佐賀県' },
	42: { key: '42', name: '長崎県' },
	43: { key: '43', name: '熊本県' },
	44: { key: '44', name: '大分県' },
	45: { key: '45', name: '宮崎県' },
	46: { key: '46', name: '鹿児島県' },
	47: { key: '47', name: '沖縄県' },
} as const;
export type PrefectureType = typeof Prefecture[keyof typeof Prefecture];

export const findPrefectureTypeNameByKey = (key: string) => {
	const prefecture = Object.values(Prefecture).find((p) => p.key === key);
	return prefecture ? prefecture.name : '';
};
